import {
  doc,
  getDoc,
  collection,
  getDocs,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import router from "@/router";
const content = {
  state: {
    categories: [],
    posts: [],
    schedule: [],
    events: [],
    query: {
      category: null,
      search: null,
      recurring: null,
      status: "all",
      knowledge: [],
    },
    generating_posts: false,
  },
  mutations: {
    setCategories(state, val) {
      state.categories = val;
    },
    addCategory(state, val) {
      state.categories.push(val);
    },
    setPosts(state, val) {
      state.posts = val;
    },
    setSchedule(state, val) {
      state.schedule = val;
    },
    setEvents(state, val) {
      state.events = val;
    },
    addPost(state, val) {
      state.posts.unshift(val);
    },
    updatePost(state, val) {
      const i = state.posts.findIndex((p) => p.uid === val.uid);
      state.posts.splice(i, 1, val);
    },
    deletePost(state, val) {
      const i = state.posts.findIndex((p) => p.uid === val);
      state.posts.splice(i, 1);
    },
    setQuery(state, val) {
      state.query = val;
    },
    removePostFromCategory(state, val) {
      let cat = val.category;
      let post = val.post;
      state.categories.find((c) => c.uid === cat).based_on = state.categories
        .find((c) => c.uid === cat)
        .based_on.filter((p) => p.id !== post);
    },
    changePostStatus(state, { status, post }) {
      const i = state.posts.findIndex((p) => p.uid === post);
      if (i !== -1) {
        state.posts[i].status = status;
      }
    },
    changeRecurring(state, { recurring, post }) {
      const i = state.posts.findIndex((p) => p.uid === post);
      if (i !== -1) {
        state.posts[i].recurring = recurring;
      }
    },
    updatePostOrderNumber(state, { uid, order_number }) {
      const i = state.posts.findIndex((p) => p.uid === uid);
      if (i !== -1) {
        state.posts.splice(i, 1, { ...state.posts[i], order_number });
      }
    },
    setGeneratingPosts(state, val) {
      state.generating_posts = val;
    },
  },
  actions: {
    async changeRecurring({ commit, rootState }, { recurring, post }) {
      await updateDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          post,
        ),
        { recurring: !recurring },
      );
      commit("changeRecurring", { recurring: !recurring, post: post });
    },

    async refreshPost({ commit, state, rootState }, uid) {
      const docSnap = await getDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          uid,
        ),
      );
      let p = docSnap.data();
      p.variations = [];
      const messages = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "posts",
          p.uid,
          "variations",
        ),
      );
      messages.forEach((d) => {
        p.variations.push(d.data());
      });
      p.category = p.category
        ? state.categories.find((c) => c.uid === p.category)
        : null;
      commit("updatePost", p);
    },
    async fetchPosts({ commit, state }) {
      commit("setLoading", { type: "posts", val: true });

      const getPostsFn = httpsCallable(functions, "getPosts");
      const res = await getPostsFn();
      let posts = res.data;

      posts.forEach((p) => {
        p.category = p.category
          ? state.categories.find((c) => c.uid === p.category)
          : null;
      });

      commit("setPosts", posts);
      commit("setLoading", { type: "posts", val: false });
    },
    async fetchCategories({ commit, state, rootState }) {
      commit("setLoading", { type: "categories", val: true });
      let categories = [];

      const querySnapshot = await getDocs(
        collection(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "categories",
        ),
      );
      querySnapshot.docs.map((doc) => {
        let cat = doc.data();
        cat.posts = [];
        categories.push(cat);
      });

      categories.sort((a, b) =>
        a.name < b.name ? -1 : b.name < a.name ? 1 : 0,
      );

      commit("setCategories", categories);
      const nonSuggested = categories.filter((c) => c.status !== "suggested");
      if (!state.query.category && nonSuggested.length > 0) {
        commit("setQuery", {
          category: nonSuggested[0].uid,
          search: null,
          recurring: null,
          status: "all",
        });
      }
      commit("setLoading", { type: "categories", val: false });
    },
    async keepCategory({ commit, rootState, state, dispatch }, category) {
      commit("setLoading", { type: "categories", val: true });
      console.log(category);
      const importPosts = httpsCallable(functions, "importPosts");
      let res;
      try {
        res = await importPosts({
          category: category,
          workspace: rootState.workspace.workspace,
        });
      } catch (error) {
        console.log(error);
      }
      console.log(res);
      await updateDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "categories",
          category.uid,
        ),
        { status: "draft" },
      );
      commit(
        "setCategories",
        state.categories.map((c) =>
          c.uid === category.uid ? { ...c, status: "draft" } : c,
        ),
      );
      dispatch("fetchCategories");
      dispatch("fetchMedia");
      dispatch("fetchPosts");
      commit("setLoading", { type: "categories", val: false });
    },
    async generatePosts(
      { commit, rootState, state, dispatch },
      { count, posts, category_uid },
    ) {
      console.log(count, posts, category_uid);
      try {
        const generatePosts = httpsCallable(functions, "generatePosts", {
          timeout: 300000,
        });
        let category = state.categories.find((c) => c.uid === category_uid);
        console.log(category);
        const res = await generatePosts({
          previous_posts: posts,
          category: {
            description: category.description || "",
            name: category.name || "",
            keywords: category.keywords || [],
            goals: category.goals || [],
          },
          brand: rootState.workspace.brand,
          language: rootState.workspace.brand?.language,
          count: count,
        });

        let new_posts = JSON.parse(res.data).posts;
        await Promise.all(
          new_posts.map((p) =>
            dispatch("savePost", { post: p, category_uid: category_uid }),
          ),
        );
        dispatch("fetchPosts");
      } catch (error) {
        console.log(error);
        commit("setNotification", {
          show: true,
          text: "Something went wrong. Please try again later.",
          type: "error",
          icon: "mdi-alert-circle",
        });
      }
    },
    async getArticlePreview(url) {
      let prefix = "https://";
      let link = url;
      if (url != "") {
        if (!link.includes("http")) {
          link = prefix.concat(url);
        }

        console.log("Getting link preview");
        const getPreview = httpsCallable(functions, "getLinkPreview");
        const res = await getPreview({
          url: link,
        });
        console.log(res.data);
        let v = res.data;
        return {
          alt: v.images,
          type: "url",
          url: v.url,
          src: v.image,
          description: v.description,
          language: v.language,
          title: v.title,
        };
      }
      return null;
    },
    async savePost({ rootState, dispatch }, { post, category_uid }) {
      let media = [];
      if (post.source) {
        media = [await dispatch("getArticlePreview", post.source)];
      }
      let postData = {
        auto_variation: true,
        auto_variation_level: "medium",
        accounts: rootState.accounts.accounts.map((a) => a.id),
        category: category_uid,
        created: Math.floor(Date.now() / 1000),
        created_by: rootState.users.userProfile.uid,
        created_by_email: rootState.users.userProfile.email,
        recurring: true,
        last_publish: null,
        scheduled: false,
        schedule_date: null,
        status: "suggested",
        media: media,
        title: post.title,
        comment: "",
        workspace: rootState.users.userProfile.workspace,
        variations: [{ text: post.post_draft, type: "main" }],
        uid: null,
        timezone: rootState.workspace.timezone,
      };
      console.log(postData);
      const addPost = httpsCallable(functions, "postAdd");
      await addPost(postData);
    },
    async fetchEvents({ commit, rootState }) {
      const dayOfMonth = (x, day, year, month) => {
        let y = 0;
        if (x === 2) {
          y = 7;
        } else if (x === 3) {
          y = 14;
        } else if (x === 4) {
          y = 21;
        } else if (x === 5) {
          y = 28;
        }
        // first day of the month
        let date = new Date(year, month, 1);
        let dayDifference = day - date.getDay();

        // get second friday of the month
        if (dayDifference < 0) {
          date.setDate(date.getDate() + (y + 7 + 1 * dayDifference));
        } else if (dayDifference >= 0) {
          date.setDate(date.getDate() + y + dayDifference);
        }

        return date;
      };

      let events = [];
      let today = new Date();

      const contentRef = doc(
        db,
        "workspaces",
        rootState.users.userProfile.workspace,
      );
      const content = await getDoc(contentRef);
      let schedule = content.data().schedule;

      commit("setSchedule", schedule);

      for (let x in schedule) {
        // find first day match
        let start = schedule[x].created.toDate();

        let day = null;
        for (let i = 0; i < 7; i++) {
          if (start.getDay() === schedule[x].day) {
            day = start;
            break;
          }
          start.setDate(start.getDate() + 1);
        }

        if (schedule[x].type === "Months") {
          let y = dayOfMonth(
            schedule[x].month_day,
            schedule[x].day,
            day.getFullYear(),
            day.getMonth(),
          );
          if (y < today) {
            y = dayOfMonth(
              schedule[x].month_day,
              schedule[x].day,
              day.getFullYear(),
              day.getMonth() + 1,
            );
          }
          day = y;
        }

        // Set timeslot for first day
        let hours = schedule[x].timeslot.split(":")[0];
        let minutes = schedule[x].timeslot.split(":")[1];
        day.setHours(hours);
        day.setMinutes(minutes);

        // Create event for that day
        let end = new Date(day.valueOf());
        end.setHours(Number(hours) + 1);

        let event = {
          name: schedule[x].category.name,
          start: day,
          end: end,
          color: schedule[x].category.color,
          timed: true,
        };

        // add (e.g.) 2 weeks to date + create event

        if (schedule[x].type === "Weeks") {
          for (let i = 0; i < 9999; i++) {
            if (day.getYear() === today.getYear() + 5) {
              break;
            }

            const newEvent = structuredClone(event);
            events.push(newEvent);

            day.setDate(day.getDate() + 7 * schedule[x].frequency);
            end.setDate(end.getDate() + 7 * schedule[x].frequency);
          }
        } else if (schedule[x].type === "Months") {
          for (let i = 0; i < 999; i++) {
            if (day.getYear() === today.getYear() + 5) {
              break;
            }

            const newEvent = structuredClone(event);
            events.push(newEvent);

            let y = dayOfMonth(
              schedule[x].month_day,
              schedule[x].day,
              day.getFullYear(),
              day.getMonth() + 1 * schedule[x].frequency,
            );

            day.setDate(y.getDate());
            day.setMonth(y.getMonth());
            day.setFullYear(y.getFullYear());
            day.setHours(Number(hours));
            day.setMinutes(minutes);
            end.setDate(y.getDate());
            end.setMonth(y.getMonth());
            end.setFullYear(y.getFullYear());
            end.setHours(Number(hours) + 1);
            end.setMinutes(minutes);
          }
        } else if (schedule[x].type === "Days") {
          for (let i = 0; i < 9999; i++) {
            if (day.getYear() === today.getYear() + 5) {
              break;
            }

            const newEvent = structuredClone(event);
            events.push(newEvent);

            day.setDate(day.getDate() + 1 * schedule[x].frequency);
            end.setDate(end.getDate() + 1 * schedule[x].frequency);
          }
        }
      }

      commit("setEvents", events);
    },
    async deleteCategory({ commit, rootState, state, dispatch }, payload) {
      const uid = typeof payload === "object" ? payload.uid : payload;
      const skipConfirm = typeof payload === "object" ? payload.silent : false;

      if (
        !skipConfirm &&
        !router.currentRoute.value.path.includes("onboarding")
      ) {
        let r = confirm("Are you sure you want to delete this category?");
        if (!r) {
          return;
        }
      }

      commit("setLoading", { type: "categories", val: true });
      await deleteDoc(
        doc(
          db,
          "workspaces",
          rootState.users.userProfile.workspace,
          "categories",
          uid,
        ),
      );
      commit(
        "setCategories",
        state.categories.filter((c) => c.uid !== uid),
      );
      commit("setCategoryShow", false);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      dispatch("fetchPosts");
      commit("setQuery", {
        category: null,
        search: null,
        recurring: null,
        status: "all",
      });
      if (!skipConfirm) {
        commit("setNotification", {
          show: true,
          text: "Category deleted!",
          type: "primary",
          icon: "",
        });
      }
      commit("setLoading", { type: "categories", val: false });
    },
  },
  getters: {},
};

export default content;
